<template>
  <div class="container">
    <!-- 视频列表页面 -->
    <div v-if="!isPlaying" class="list-container">
         <!-- 顶部Tab标签页 -->
      <div class="tab-container">
        <div class="tab-header">
          <div 
            v-for="(tab, index) in tabs" 
            :key="index"
            class="tab-item"
            :class="{ active: activeTab === tab.key }"
            @click="switchTab(tab.key)"
          >
            {{ tab.name }}
          </div>
        </div>
      </div>
      <div class="video-grid">
        <div 
          v-for="(video, index) in filteredVideoList" 
          :key="index"
          class="video-card"
          :class="{ active: currentVideoIndex === index }"
          @click="playVideo(index)"
        >
          <div class="video-thumbnail">
            <img 
              :src="video.image || defaultThumbnail" 
              :alt="video.name" 
              v-if="video.thumbnail || defaultThumbnail"
              @error="handleImageError(index)"
            >
            <div v-else class="loading-thumb">加载中...</div>
            <!-- 播放图标覆盖层 -->
            <div class="play-overlay" v-if="!video.thumbnail">
              <div class="play-icon">▶</div>
            </div>
          </div>
          <div class="video-info">
            <div class="video-name">{{ video.name }}</div>
            <div class="video-details">
              <span class="video-number">{{ video.number || '10' }}次</span>
              <span class="video-remark">{{ video.remark }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 视频播放页面 -->
    <div v-else class="player-container">
      <div class="player-header">
        <button class="back-button" @click="backToList">←</button>
        <div class="player-title">{{ currentVideo.name }}</div>
      </div>
      
      <div class="video-player-container">
        <div class="video-wrapper">
          <video 
            ref="videoPlayer"
            class="video-player"
            :src="currentVideo.videoUrl"
            Controlslist=nodownload
            controls
            webkit-playsinline
            playsinline
            x5-playsinline
            @loadeddata="onVideoLoaded"
          ></video>
        </div>
      </div>
      
      <div class="video-controls">
        <div class="video-info-panel">
          <div class="info-title">{{ currentVideo.name }}</div>
          <div class="info-details">
            <p>备注: {{ currentVideo.remark }}</p>
          </div>
          <!-- <div>< 返回</div> -->
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'VideoPlayer',
  data() {
    return {
      isPlaying: false,
      currentVideoIndex: -1,
      activeTab: 'all', // 默认显示全部
      tabs: [
        { key: 'all', name: '全部' },
        { key: '0', name: '讲解' },
        { key: '1', name: '体测示范' },
        { key: '2', name: '空手训练' },
        { key: '3', name: '器材训练' },
      ],
      defaultThumbnail: require('../parentHomePage/image/跳绳视频.png'),





      classroomvideoList: [
        {name:'肺活量讲解',number:'10',category:'0',remark:"备注说明", image:require('./img/cover1.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/肺活量讲解.mp4"},
        {name:'立定跳远讲解',number:'10',category:'0',remark:"备注说明", image:require('./img/cover1.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/立定跳远讲解.mp4"},
        {name:'实心球讲解',number:'10',category:'0',remark:"备注说明", image:require('./img/cover1.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/实心球讲解.mp4"},
        {name:'跳绳运动讲解',number:'10',category:'0',remark:"备注说明", image:require('./img/跳绳.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/跳绳运动讲解.mp4"},
        {name:'仰卧起坐讲解',number:'10',category:'0',remark:"备注说明", image:require('./img/cover1.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/仰卧起坐讲解.mp4"},
        {name:'引体向上讲解',number:'10',category:'0',remark:"备注说明", image:require('./img/cover1.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/引体向上讲解.mp4"},
        {name:'坐位体前屈讲解',number:'10',category:'0',remark:"备注说明", image:require('./img/cover1.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/坐位体前屈讲解.mp4"},
        {name:'直道短跑讲解',number:'10',category:'0',remark:"备注说明", image:require('./img/cover1.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/直道短跑讲解.mp4"},
        {name:'耐力跑讲解',number:'10',category:'0',remark:"备注说明", image:require('./img/cover1.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/耐力跑讲解.mp4"},

        


        {name:'立走跳远动作示范',number:'10',category:'1',remark:"备注说明", image:require('./img/cover1.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/立走跳远动作示范.mp4"},
        {name:'实心球动作示范',number:'10',category:'1',remark:"备注说明", image:require('./img/cover1.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/实心球动作示范.mp4"},
        {name:'跳绳运动示范跟练',number:'10',category:'1',remark:"备注说明", image:require('./img/跳绳.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/跳绳运动示范跟练.mp4"},
        {name:'仰卧起坐示范跟练',number:'10',category:'1',remark:"备注说明", image:require('./img/cover1.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/仰卧起坐示范跟练.mp4"},
        {name:'引体向上动作示范',number:'10',category:'1',remark:"备注说明", image:require('./img/cover1.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/引体向上动作示范.mp4"},
        {name:'坐位体前屈动作示范',number:'10',category:'1',remark:"备注说明", image:require('./img/cover1.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/坐位体前屈动作示范.mp4"},
        {name:'直道短跑示范',number:'10',category:'1',remark:"备注说明", image:require('./img/cover1.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/直道短跑示范.mp4"},
        {name:'耐力跑示范',number:'10',category:'1',remark:"备注说明", image:require('./img/cover1.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/耐力跑示范.mp4"},
      







        {name:'卷腹跳',number:'10',category:'2',remark:"备注说明", image:require('./img/cover1.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/卷腹跳.mp4"},
        {name:'泡沫轴大腿前侧滚动右',remark:"备注说明",number:'10',category:'2', image:require('./img/泡沫轴大腿前侧滚动右.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/泡沫轴大腿前侧滚动右.mp4"},
        {name:'泡沫轴大腿前侧滚动左',remark:"备注说明",number:'10',category:'2', image:require('./img/泡沫轴大腿前侧滚动左.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/泡沫轴大腿前侧滚动左.mp4"},
        {name:'右脚单脚支撑摆臂',number:'10',category:'2', image:require('./img/cover1.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/右脚单脚支撑摆臂.mp4"},
        {name:'右腿单腿臀桥',number:'10',category:'2', image:require('./img/cover1.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/右腿单腿臀桥.mp4"},
        {name:'左脚单脚支撑摆臂',number:'10',category:'2', image:require('./img/cover1.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/左脚单脚支撑摆臂.mp4"},
        {name:'左腿单腿臀桥',number:'10',category:'2', image:require('./img/cover1.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/左腿单腿臀桥.mp4"},
        {name:'9090胯部激活',number:'10',category:'2', image:require('./img/cover1.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/9090胯部激活.mp4"},
        {name:'猫式伸展',number:'10',category:'2', image:require('./img/cover1.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/猫式伸展.mp4"},
        {name:'平板支撑',number:'10',category:'2', image:require('./img/cover1.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/平板支撑.mp4"},
        {name:'双手快速摆臂',number:'10',category:'2', image:require('./img/cover1.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/双手快速摆臂.mp4"},
        {name:'死虫式',number:'10',category:'2', image:require('./img/cover1.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/死虫式.mp4"},
        {name:'握拳快速绕腕',number:'10',category:'2', image:require('./img/cover1.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/握拳快速绕腕.mp4"},
        {name:'婴儿式',number:'10',category:'2', image:require('./img/cover1.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/婴儿式.mp4"},
        {name:'展腹跳',number:'10',category:'2', image:require('./img/cover1.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/展腹跳.mp4"},





        {name:'阻力带踮脚跳',number:'10',category:'3', image:require('./img/阻力带踮脚跳.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/阻力带踮脚跳.mp4"},
        {name:'阻力带深蹲',number:'10',category:'3', image:require('./img/阻力带深蹲.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/阻力带深蹲.mp4"},
        {name:'阻力带下拉',number:'10',category:'3', image:require('./img/阻力带下拉.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/阻力带下拉.mp4"},
        {name:'阻力带旋转',number:'10',category:'3', image:require('./img/阻力带旋转.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/阻力带旋转.mp4"},
        {name:'阻力带硬拉',number:'10',category:'3', image:require('./img/阻力带硬拉.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/阻力带硬拉.mp4"},
        {name:'阻力带右腿拉伸',number:'10',category:'3', image:require('./img/阻力带右腿拉伸.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/阻力带右腿拉伸.mp4"},
        {name:'阻力带左腿拉伸',number:'10',category:'3', image:require('./img/阻力带左腿拉伸.png'),videoUrl:"https://cppu.xtotoro.com/longmao/video/阻力带左腿拉伸.mp4"},
 
      ]
    }
  },
  computed: {
    currentVideo() {
      return this.currentVideoIndex >= 0 ? this.filteredVideoList[this.currentVideoIndex] : {}
    },
    // 根据当前tab过滤视频列表
    filteredVideoList() {
      if (this.activeTab === 'all') {
        return this.classroomvideoList;
      }
      console.log(this.classroomvideoList.filter(video => video.category == this.activeTab));
      
      return this.classroomvideoList.filter(video => video.category == this.activeTab);
    }
  },
  mounted() {
    // 组件挂载后生成缩略图
    // this.generateThumbnails();
    
    // 根据路由参数查找视频索引
    const videoName = this.$route.query.name;
    if (videoName) {
      this.findVideoIndexByName(videoName);
    }
  },
  methods: {
     // 切换Tab
    switchTab(tabKey) {
        console.log(tabKey);
        
      this.activeTab = tabKey;
    },
    // 生成所有视频的缩略图
    async generateThumbnails() {
      // 只为前6个视频生成缩略图，避免过多请求
      const limit = Math.min(6, this.classroomvideoList.length);
      for (let i = 0; i < limit; i++) {
        if (!this.classroomvideoList[i].thumbnail) {
          try {
            // const thumbnail = await this.getVideoBase64(this.classroomvideoList[i].videoUrl);
            this.$set(this.classroomvideoList[i], 'thumbnail', this.defaultThumbnail);
          } catch (error) {
            console.log(`生成缩略图失败 for ${this.classroomvideoList[i].name}:`, error);
            // 如果生成失败，使用默认图片
            this.$set(this.classroomvideoList[i], 'thumbnail', this.defaultThumbnail);
          }
        }
      }
    },
    async  getVideoBase64(url, second = 0) {
	return new Promise((resolve) => {
		const video = document.createElement("video");
		video.setAttribute("crossOrigin", "anonymous"); // 处理跨域
		video.setAttribute("src", url);
		// 静音操作，防止播放失败
		video.setAttribute("muted", "muted");
		video.onloadeddata = () => {
			video.currentTime = second;
			video.onseeked = async () => {
				const canvas = document.createElement("canvas");
				console.dir(video);
				const { videoWidth: width, videoHeight: height } = video; // canvas的尺寸和图片一样
				canvas.width = width;
				canvas.height = height;
				canvas.getContext("2d")?.drawImage(video, 0, 0, width, height);
				resolve(canvas.toDataURL("image/png"));
			};
		};
	});
},
    // 生成单个视频的缩略图 - 改进版本
    generateVideoThumbnail(videoUrl) {
      return new Promise((resolve, reject) => {
        // 创建临时video元素
        const video = document.createElement('video');
        video.src = videoUrl;
        video.crossOrigin = 'anonymous';
        video.muted = true;
        video.autoplay = true;
        
        // 隐藏视频元素，防止在页面上显示
        video.style.position = 'absolute';
        video.style.left = '-9999px';
        video.style.top = '-9999px';
        video.style.width = '320px';
        video.style.height = '180px';
        video.style.zIndex = '-1';
        
        // 添加到DOM中但不可见
        document.body.appendChild(video);
        
        let hasCapturedFrame = false;
        let cleanupTimer = null;
        
        // 监听播放事件
        const handlePlay = () => {
          // 等待一小段时间确保第一帧渲染完成
          setTimeout(() => {
            if (!hasCapturedFrame) {
              try {
                // 创建canvas来截取第一帧
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                
                // 设置canvas尺寸为视频尺寸
                canvas.width = video.videoWidth || 320;
                canvas.height = video.videoHeight || 180;
                
                // 绘制第一帧
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                
                // 转换为base64图片
                const thumbnail = canvas.toDataURL('image/jpeg', 0.8);
                
                // 标记已捕获帧
                hasCapturedFrame = true;
                
                // 清理资源
                video.remove();
                canvas.remove();
                
                // 清除定时器
                if (cleanupTimer) {
                  clearTimeout(cleanupTimer);
                }
                
                resolve(thumbnail);
              } catch (error) {
                cleanup();
                reject(error);
              }
            }
          }, 100); // 等待100ms确保第一帧渲染
        };
        
        // 监听错误事件
        const handleError = (error) => {
          cleanup();
          reject(error);
        };
        
        // 清理函数
        const cleanup = () => {
          video.remove();
          if (cleanupTimer) {
            clearTimeout(cleanupTimer);
          }
        };
        
        // 添加事件监听器
        video.addEventListener('play', handlePlay);
        video.addEventListener('error', handleError);
        
        // 设置加载时间限制
        cleanupTimer = setTimeout(() => {
          if (!hasCapturedFrame) {
            cleanup();
            reject(new Error('视频加载超时'));
          }
        }, 5000);
        
        // 开始加载视频
        video.load();
      });
    },
    
    // 处理图片加载错误
    handleImageError(index) {
      this.$set(this.filteredVideoList[index], 'thumbnail', this.defaultThumbnail);
    },
    
    // 根据视频名称查找索引
    findVideoIndexByName(name) {
      const index = this.classroomvideoList.findIndex(video => video.name === name);
      if (index !== -1) {
        this.currentVideoIndex = index;
        this.isPlaying = true;
        this.$nextTick(() => {
          if (this.$refs.videoPlayer) {
            this.$refs.videoPlayer.play().catch(error => {
              console.log('自动播放失败:', error);
            });
          }
        });
      }
    },
    
    playVideo(index) {
      this.currentVideoIndex = index;
      this.isPlaying = true;
      this.$nextTick(() => {
        if (this.$refs.videoPlayer) {
          // 设置poster属性为视频第一帧
          this.$refs.videoPlayer.poster = this.filteredVideoList[index].thumbnail || this.defaultThumbnail;
          this.$refs.videoPlayer.play().catch(error => {
            console.log('自动播放失败:', error);
          });
        }
      });
    },
    
    backToList() {
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.pause();
        this.$refs.videoPlayer.currentTime = 0;
      }
      this.isPlaying = false;
      this.currentVideoIndex = -1;
    },
    
    onVideoLoaded() {
      console.log('视频加载完成');
    }
  },
  beforeDestroy() {
    if (this.$refs.videoPlayer) {
      this.$refs.videoPlayer.pause();
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 100%;
  margin: 0 auto;
  /* padding: 0 10px; */
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.list-container {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 15px 20px;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  position: sticky;
  top: 0;
  z-index: 100;
}

.header h1 {
  font-size: 1.5rem;
  font-weight: 500;
  margin: 0;
}
/* Tab标签页样式 */
.tab-container {
  background: white;
  /* box-shadow: 0 2px 5px rgba(0,0,0,0.1); */
  position: sticky;
  top: 0;
  z-index: 100;
}

.tab-header {
  display: flex;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
  /* background-color: #a19595; */
}

.tab-header::-webkit-scrollbar {
  display: none;
}

.tab-item {
  flex: 1;
  min-width: 80px;
  padding: 5px 6px;
  margin: 15px 10px;
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  border: 1px solid #999;
  color: #000;
  border-radius: 15px;
  background-color: #fff;
}

.tab-item.active {
  color: white;
  background-color: #333131;
}

.tab-item:hover {
 /* color: white;
  background-color: #333131; */
}
.video-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  padding: 15px 10px;
}

.video-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid #eee;
  overflow: hidden;
  position: relative;
}

.video-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0,0,0,0.15);
}

.video-card.active {
  border-color: #667eea;
  background-color: #f8f9ff;
}

.video-thumbnail {
  width: 100%;
  height: 120px;
  position: relative;
  overflow: hidden;
  background-color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.loading-thumb {
  font-size: 12px;
  color: #999;
  text-align: center;
}

.play-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}

.play-icon {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333;
  font-size: 16px;
  line-height: 1;
}

.video-info {
  padding: 12px;
}

.video-name {
  font-size: 0.95rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 6px;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.video-details {
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  color: #666;
}

.video-number {
  background-color: #667eea;
  color: white;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 0.7rem;
  margin-right: 8px;
}

.video-remark {
  flex: 1;
  color: #888;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.player-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  z-index: 1000;
  display: flex;
  flex-direction: column;
}

.player-header {
  padding: 15px 20px;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  color: white;
  position: relative;
}

.back-button {
  background: none;
  border: none;
  color: white;
  font-size: 1.2rem;
  cursor: pointer;
  padding: 5px 10px;
  margin-right: 10px;
  z-index: 1001;
}

.player-title {
  flex: 1;
  font-size: 1.1rem;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  max-width: 70%;
}

.video-player-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: #000;
}

.video-wrapper {
  width: 100%;
  max-width: 100%;
  position: relative;
}

.video-player {
  width: 100%;
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  outline: none;
  background: #000;
}

.video-controls {
  padding: 20px;
  background: rgba(0, 0, 0, 0.9);
  color: white;
  text-align: center;
}

.video-info-panel {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 15px;
}

.info-title {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 8px;
}

.info-details {
  font-size: 0.9rem;
  color: #ccc;
  line-height: 1.5;
}

/* 确保在所有屏幕尺寸下都是一行两个 */
@media (min-width: 320px) {
  .video-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 480px) {
  .video-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 768px) {
  .video-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .video-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 320px) {
  .video-grid {
    grid-template-columns: 1fr;
  }
  
  .video-thumbnail {
    height: 140px;
  }
}
</style>
```